import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./DropdownMenu.module.sass";
import Icon from "../../Icon";

const DropdownMenu = ({ item, className, setValue }) => {
    const [visible, setVisible] = useState(false);

    const { pathname } = useLocation();

    const handleClick = () => {
        setValue(false);
        setVisible(false);
    };

    return (
        <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
            <div className={cn(styles.group, className)}>
                <div
                    className={cn(
                        styles.head,
                        { [styles.open]: visible },
                        { [styles.active]: pathname.startsWith("/features") }
                    )}
                    onClick={() => setVisible(!visible)}
                >
                    {item.title}
                    <Icon name="arrow-bottom" size="9" />
                </div>
                {visible && (
                    <div className={styles.body}>
                        <div className={styles.inner}>
                            <div className={styles.row}>
                                <div className={styles.col}>
                                    <div className={styles.direction}>
                                        <div className={styles.info}>
                                            {item.content.info}
                                        </div>
                                    </div>
                                    <div className={styles.menu}>
                                        {item.content.menu.map(
                                            (item, index) => (
                                                <NavLink
                                                    className={cn(styles.box, {
                                                        [styles.active]:
                                                            pathname ===
                                                            item.url,
                                                    })}
                                                    to={item.url}
                                                    key={index}
                                                    onClick={() =>
                                                        handleClick()
                                                    }
                                                >
                                                    <div
                                                        className={styles.icon}
                                                    >
                                                        <img
                                                            src={item.image}
                                                            alt={item.title}
                                                        />
                                                    </div>
                                                    <div
                                                        className={
                                                            styles.subtitle
                                                        }
                                                    >
                                                        {item.title}
                                                    </div>
                                                </NavLink>
                                            )
                                        )}
                                    </div>
                                </div>
                                <div className={styles.col}>
                                    <div className={styles.line}>
                                        <div className={styles.cell}>
                                            {item.content.links.map(
                                                (item, index) =>
                                                    index === 0 && (
                                                        <Link
                                                            className={
                                                                styles.card
                                                            }
                                                            to={item.url}
                                                            key={index}
                                                            onClick={() =>
                                                                handleClick()
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    styles.photo
                                                                }
                                                            >
                                                                <img
                                                                    srcSet={`${item.image2x} 2x`}
                                                                    src={
                                                                        item.image
                                                                    }
                                                                    alt={
                                                                        item.status
                                                                    }
                                                                />
                                                                <div
                                                                    className={cn(
                                                                        {
                                                                            "status-black":
                                                                                item.category ===
                                                                                "black",
                                                                        },
                                                                        {
                                                                            "status-green":
                                                                                item.category ===
                                                                                "green",
                                                                        },
                                                                        {
                                                                            "status-red":
                                                                                item.category ===
                                                                                "red",
                                                                        },
                                                                        {
                                                                            "status-purple":
                                                                                item.category ===
                                                                                "purple",
                                                                        },
                                                                        {
                                                                            "status-blue":
                                                                                item.category ===
                                                                                "blue",
                                                                        },
                                                                        {
                                                                            "status-yellow":
                                                                                item.category ===
                                                                                "yellow",
                                                                        },
                                                                        styles.category
                                                                    )}
                                                                >
                                                                    {
                                                                        item.categoryText
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={
                                                                    styles.top
                                                                }
                                                            >
                                                                <div
                                                                    className={
                                                                        styles.user
                                                                    }
                                                                >

                                                                    <div
                                                                        className={
                                                                            styles.details
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                styles.title
                                                                            }
                                                                        >
                                                                            {
                                                                                item.title
                                                                            }
                                                                        </div>
                                                                        <div
                                                                            className={
                                                                                styles.trainer
                                                                            }
                                                                        >
                                                                            {
                                                                                item.trainer
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={cn(
                                                                        {
                                                                            "status-stroke-green":
                                                                                item.level ===
                                                                                "green",
                                                                        },
                                                                        {
                                                                            "status-blue":
                                                                                item.level ===
                                                                                "blue",
                                                                        },
                                                                        styles.level
                                                                    )}
                                                                >
                                                                    {
                                                                        item.levelText
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={
                                                                    styles.content
                                                                }
                                                            >
                                                                {item.content}
                                                            </div>
                                                        </Link>
                                                    )
                                            )}
                                        </div>
                                        <div className={styles.cell}>
                                            {item.content.links.map(
                                                (item, index) =>
                                                    index > 0 && (
                                                        <Link
                                                            className={
                                                                styles.item
                                                            }
                                                            to={item.url}
                                                            key={index}
                                                            onClick={() =>
                                                                handleClick()
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    styles.photo
                                                                }
                                                            >
                                                                <img
                                                                    srcSet={`${item.image2x} 2x`}
                                                                    src={
                                                                        item.image
                                                                    }
                                                                    alt={
                                                                        item.category
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                className={
                                                                    styles.description
                                                                }
                                                            >
                                                                <div
                                                                    className={cn(
                                                                        {
                                                                            "status-black":
                                                                                item.category ===
                                                                                "black",
                                                                        },
                                                                        {
                                                                            "status-green":
                                                                                item.category ===
                                                                                "green",
                                                                        },
                                                                        {
                                                                            "status-red":
                                                                                item.category ===
                                                                                "red",
                                                                        },
                                                                        {
                                                                            "status-blue":
                                                                                item.category ===
                                                                                "blue",
                                                                        },
                                                                        styles.category
                                                                    )}
                                                                >
                                                                    {
                                                                        item.categoryText
                                                                    }
                                                                </div>
                                                                <div
                                                                    className={
                                                                        styles.user
                                                                    }
                                                                >
                                                                    <div
                                                                        className={
                                                                            styles.details
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                styles.title
                                                                            }
                                                                        >
                                                                            {
                                                                                item.title
                                                                            }
                                                                        </div>
                                                                        <div
                                                                            className={
                                                                                styles.trainer
                                                                            }
                                                                        >
                                                                            {
                                                                                item.description
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </OutsideClickHandler>
    );
};

export default DropdownMenu;
